// src/models/product.model.js
// export const mapProduct = (data) => ({
//   id: data.id || 0,
//   name: data.name || "",
//   code: data.code || "",
//   price: data.price || 0,
//   priceAfterDiscount: data.priceAfterDiscount || 0,
//   discount: data.discount || 0,
//   description: data.description || "",
//   categoryName: data.categoryName || "",
//   isDelivered: data.is_deliverd || 0,
//   deliveryType: data.delivery_type || "",
//   feesInternal: data.fees_internal || 0,
//   feesExternal: data.fees_external || 0,
//   stock: data.stock || 0,
//   currencyType: data.currency_type || "",
//   isInstallment: data.is_installment || 0,
//   status: data.status || "",
//   totalRate: data.total_rate || 0,
//   avgRate: data.avg_rate || 0,
//   linkInsta: data.linkInsta || null,
//   linkWhatsapp: data.linkWhatsapp || null,
//   linkSnab: data.linkSnab || null,
//   linkFacebook: data.linkFacebook || null,
//   images: Array.isArray(data.image) ? data.image : [],
//   isFavorite: data.is_favorite || false,
// });
// export const mapProduct = (item) => {
//   return {
//     id: item.id,
//     name: item.name,
//     description: item.description,
//     price: item.priceAfterDiscount || item.price,
//     oldPrice: item.priceAfterDiscount ? item.price : null,
//     discount: item.discount,
//     image: item.image?.[0] || "",
//     stock: item.stock,
//     currency: item.currency_type,
//     isFavorite: item.is_favorite,
//     status: item.status
//   };
// };
export const mapProduct = (item) => {
  return {
    id: item.id || 0,
    name: item.name || "",
    code: item.code || "",

    price: item.price || 0,
    priceAfterDiscount: item.priceAfterDiscount || 0,
    discount: item.discount || 0,

    description: item.description || "",
    categoryName: item.categoryName || "",

    stock: item.stock || 0,
    currencyType: item.currency_type || "",

    status: item.status || "",
    isFavorite: item.is_favorite || false,

    image: item.image?.[0] || "",
    images: Array.isArray(item.image) ? item.image : [],
  };
};